module.exports = __webpack_public_path__ + "img/policeman.53844463.svg";